import { useShowBalanceStore } from '../services/show-balance-service/service-store/service-store';
import { showBalanceServiceCheckVisibleSelector } from '../services/show-balance-service/service-store/selectors';
export var useCheckShowBalance = function (wallet) {
    var isBalanceVisible = useShowBalanceStore(showBalanceServiceCheckVisibleSelector(wallet));
    return isBalanceVisible;
};
